export default {
    methods: {
        generateBarcode(unitOfMeasure, id) {
            // company code
            let barcode = '2'

            // pc or kilo
            if (this.$t('unitOfMeasure.kg') === unitOfMeasure || this.$t('unitOfMeasure.g') === unitOfMeasure) {
                barcode += '1'
            } else {
                barcode += '0'
            }

            // id of product
            barcode += (id + 100000).toString().slice(1)

            // amount in kilo
            barcode += '00000'

            // calc checkDigit
            let checkDigit = this.calculateCheckDigit(barcode)

            if (checkDigit !== 0) {
                checkDigit = 10 - checkDigit
            }

            return barcode + checkDigit
        },
        calculateCheckDigit(barcode) {
            // sum even
            let even =
                parseInt(barcode[1]) +
                parseInt(barcode[3]) +
                parseInt(barcode[5]) +
                parseInt(barcode[7]) +
                parseInt(barcode[9]) +
                parseInt(barcode[11])

            even *= 3

            // sum odd
            let odd =
                parseInt(barcode[0]) +
                parseInt(barcode[2]) +
                parseInt(barcode[4]) +
                parseInt(barcode[6]) +
                parseInt(barcode[8]) +
                parseInt(barcode[10])

            return (even + odd) % 10
        }
    }
}